/**
 * Compatibility bridge: handles Bootstrap data-bs-* attributes via MDB UI Kit.
 * This allows existing templates with data-bs-toggle="modal", data-bs-dismiss="modal",
 * data-bs-toggle="collapse", data-bs-toggle="dropdown", data-bs-toggle="tooltip",
 * data-bs-toggle="popover", data-bs-toggle="tab", data-bs-toggle="offcanvas"
 * to work with mdb-ui-kit without changing all Twig templates.
 */
import { Alert, Modal, Collapse, Dropdown, Tab, Tooltip, Popover, Offcanvas, Input, initMDB } from "mdb-ui-kit";

// Wait for DOM to be ready before querying elements
function initOnReady() {
  // Auto-init MDB Input on elements with correct structure (must have <label>)
  document.querySelectorAll('[data-mdb-input-init]').forEach(function (el) {
    if (el.querySelector('label')) {
      Input.getOrCreateInstance(el);
    }
  });

  // Auto-init other MDB components via data-mdb-*-init attributes
  initMDB({ Modal, Collapse, Dropdown, Tab, Tooltip, Popover, Offcanvas });

  // Tooltip: data-bs-toggle="tooltip"
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function (el) {
    new Tooltip(el);
  });

  // Popover: data-bs-toggle="popover"
  document.querySelectorAll('[data-bs-toggle="popover"]').forEach(function (el) {
    new Popover(el);
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initOnReady);
} else {
  initOnReady();
}

// Click-based handlers (delegation — work regardless of DOM timing)

// Modal: data-bs-toggle="modal" data-bs-target="#id"
document.addEventListener("click", function (e) {
  const trigger = e.target.closest('[data-bs-toggle="modal"]');
  if (!trigger) return;

  const targetSelector = trigger.getAttribute("data-bs-target") || trigger.getAttribute("href");
  if (!targetSelector) return;

  const modalEl = document.querySelector(targetSelector);
  if (!modalEl) return;

  e.preventDefault();
  const modal = Modal.getOrCreateInstance(modalEl);
  modal.toggle();
});

// Dismiss modal: data-bs-dismiss="modal"
document.addEventListener("click", function (e) {
  const trigger = e.target.closest('[data-bs-dismiss="modal"]');
  if (!trigger) return;

  const modalEl = trigger.closest(".modal");
  if (!modalEl) return;

  const modal = Modal.getInstance(modalEl);
  if (modal) modal.hide();
});

// Collapse: data-bs-toggle="collapse" data-bs-target="#id"
document.addEventListener("click", function (e) {
  const trigger = e.target.closest('[data-bs-toggle="collapse"]');
  if (!trigger) return;

  const targetSelector = trigger.getAttribute("data-bs-target") || trigger.getAttribute("href");
  if (!targetSelector) return;

  const collapseEl = document.querySelector(targetSelector);
  if (!collapseEl) return;

  e.preventDefault();
  const collapse = Collapse.getOrCreateInstance(collapseEl, { toggle: false });
  collapse.toggle();
});

// Dropdown: data-bs-toggle="dropdown"
document.addEventListener("click", function (e) {
  const trigger = e.target.closest('[data-bs-toggle="dropdown"]');
  if (!trigger) return;

  // If MDB already manages this dropdown, let its own handler take over
  if (Dropdown.getInstance(trigger)) return;

  e.preventDefault();
  const dropdown = Dropdown.getOrCreateInstance(trigger);
  dropdown.toggle();
});

// Tab: data-bs-toggle="tab" / data-bs-toggle="pill"
document.addEventListener("click", function (e) {
  const trigger = e.target.closest('[data-bs-toggle="tab"], [data-bs-toggle="pill"]');
  if (!trigger) return;

  e.preventDefault();
  const tab = Tab.getOrCreateInstance(trigger);
  tab.show();
});

// Offcanvas: data-bs-toggle="offcanvas" data-bs-target="#id"
document.addEventListener("click", function (e) {
  const trigger = e.target.closest('[data-bs-toggle="offcanvas"]');
  if (!trigger) return;

  const targetSelector = trigger.getAttribute("data-bs-target") || trigger.getAttribute("href");
  if (!targetSelector) return;

  const offcanvasEl = document.querySelector(targetSelector);
  if (!offcanvasEl) return;

  e.preventDefault();
  const offcanvas = Offcanvas.getOrCreateInstance(offcanvasEl);
  offcanvas.toggle();
});

// Dismiss alert: data-bs-dismiss="alert" / data-mdb-dismiss="alert"
document.addEventListener("click", function (e) {
  const trigger = e.target.closest('[data-bs-dismiss="alert"]');
  if (!trigger) return;

  const alertEl = trigger.closest(".alert");
  if (!alertEl) return;

  const alert = Alert.getOrCreateInstance(alertEl);
  if (alert) alert.close();
});

// Dismiss offcanvas: data-bs-dismiss="offcanvas"
document.addEventListener("click", function (e) {
  const trigger = e.target.closest('[data-bs-dismiss="offcanvas"]');
  if (!trigger) return;

  const offcanvasEl = trigger.closest(".offcanvas");
  if (!offcanvasEl) return;

  const offcanvas = Offcanvas.getInstance(offcanvasEl);
  if (offcanvas) offcanvas.hide();
});
